"use client";

import styles from "./SignUpRegistrationSteps.module.scss";

import { createForm, setFieldValue } from "@/stores";
import { useSteps } from "@/hooks";

import { useEffect, useMemo } from "react";

import {
  // SignUpVerifyPhoneNumberStep,
  SignUpAccountDetailsStep,
  SignUpCreatePasswordStep,
} from "..";
import { Flex } from "@vetty/ui";

// Form field definitions for registration
const REGISTRATION_FORM_FIELDS: string[] = [
  "firstName",
  "lastName",
  "email",
  // "phonePrefix",
  // "phoneNumber",
  // "phoneVerificationCode",
  "password",
  "repeatPassword",
  "termsAccepted",
  "termsAcceptedAt",
];

// Step component mapping for cleaner rendering
const STEP_COMPONENTS = {
  1: SignUpAccountDetailsStep,
  // 2: SignUpVerifyPhoneNumberStep,
  2: SignUpCreatePasswordStep,
} as const;

type StepNumber = keyof typeof STEP_COMPONENTS;

/**
 * SignUpRegistrationSteps Component
 *
 * Handles the registration process with multiple steps.
 * Renders the appropriate step component based on the current step.
 */
export const SignUpRegistrationSteps = () => {
  const { currentStep } = useSteps();

  // Initialize form with all required fields
  useEffect(() => {
    createForm(REGISTRATION_FORM_FIELDS);
    setFieldValue("termsAccepted", false);
    setFieldValue("termsAcceptedAt", "");
  }, []);

  // Get current step component
  const CurrentStepComponent = useMemo(() => {
    return STEP_COMPONENTS[currentStep as StepNumber];
  }, [currentStep]);

  return (
    <Flex direction={"column"} justify={"center"} className={styles["comp"]}>
      <Flex align={"center"} className={styles["comp__content"]}>
        {CurrentStepComponent && <CurrentStepComponent />}
      </Flex>
    </Flex>
  );
};
